import React from 'react'
import { CCard, CCol, CRow } from '@coreui/react'
import CustomImage from 'src/components/customImage/customImage'
import PublishIcon from '../../../assets/publish-icon.svg'

const TemplateSelection = ({ baseTemplateData, allowedTemplates = [], setAllowedTemplates }) => {
  const cardStyles = {
    width: '21vw',
    height: '16vw',
    borderRadius: '0',
    boxShadow: ' 3px 3px 6px rgba(0,0,0,0.16)',
    aspectRatio: '45/34',
    overflow: 'hidden',
    postion: 'relative',
  }

  const handleSelect = (info) => {
    let temp = allowedTemplates
    if (allowedTemplates.includes(info._id)) {
      temp = allowedTemplates.filter((e) => e !== info._id)
    } else {
      temp.push(info._id)
    }
    setAllowedTemplates([...temp])
  }

  return (
    <CCard
      className="rounded-0 scrollbar position-relative"
      style={{
        padding: '4.2%',
        height: '70vh',
      }}
    >
      <CRow xs={{ cols: 3, gutter: 4 }}>
        {baseTemplateData &&
          baseTemplateData.map((info, idx) => (
            <CCol key={idx}>
              <CCard className="blue-hover" style={cardStyles} onClick={() => handleSelect(info)}>
                <div className="w-100 h-100 position-relative" style={{ zindex: 0 }}>
                  {allowedTemplates.includes(info._id) && (
                    <img
                      src={PublishIcon}
                      className="position-absolute"
                      style={{ zIndex: 25, right: 0 }}
                      alt="PublishIcon"
                    />
                  )}
                  <CustomImage
                    imageUrl={info?.preview_s3_key?.website}
                    imgClass="w-100 position-absolute"
                    imgStyle={{ borderRadius: '0', zIndex: 0 }}
                    loaderClass="w-100 h-100"
                    loaderStyle={{ background: '#5A5A5A50' }}
                    imgAlt={'thumbnail'}
                  />
                </div>
                <div className="template-card-cardBody">
                  <div>
                    <span style={{ fontWeight: '500', color: '#191818', fontSize: '15px' }}>
                      {info.template_name}
                    </span>
                  </div>
                </div>
              </CCard>
            </CCol>
          ))}
      </CRow>
    </CCard>
  )
}

export default TemplateSelection
